import React from "react";

import { Panel, Th } from "./Panel";
import { useTranslation } from "react-i18next";

/**
 * Shipment tracking — carrier scan events from `shipment_histories`.
 *
 * These are CARRIER events, not an audit trail. The design's "Activity on this
 * invoice" panel would have to render from something else; there is no
 * shipment-level audit endpoint, so it is not built. Presenting carrier scans
 * as admin billing actions would be actively misleading in a dispute.
 *
 * Date/time slice offsets match Tracking.jsx: StatusDate carries both.
 */
const TrackingPanel = ({ data }) => {
  const { t } = useTranslation("admin");
  const events = data?.shipment_histories || [];

  return (
    <Panel
      title={t("invoice.shipmentTracking")}
      chip={events.length ? t("invoice.scanCount", { count: events.length }) : null}
      hint={t("invoice.carrierScanEvents")}
    >
      <table className="w-full border-collapse tabular-nums">
        <thead>
          <tr className="border-b border-ui-border-strong bg-ui-surface-sunken">
            <Th>{t("invoice.shipmentStatus")}</Th>
            <Th>{t("invoice.statusDate")}</Th>
            <Th>{t("invoice.statusTime")}</Th>
            <Th>{t("invoice.lastLocation")}</Th>
          </tr>
        </thead>
        <tbody className="font-manrope text-[11.5px] font-medium text-ui-text">
          {events.map((history, index) => (
            <tr
              key={index}
              className="border-b border-ui-border-subtle hover:bg-ui-row-hover"
            >
              <td className="px-[9px] py-1 font-semibold">
                {history?.ShipmentStatus ?? "-"}
              </td>
              <td className="px-[9px] py-1 text-ui-text-secondary">
                {history?.StatusDate?.slice(0, 10) ?? "-"}
              </td>
              <td className="px-[9px] py-1 text-ui-text-secondary">
                {history?.StatusDate?.slice(11, 16) ?? "-"}
              </td>
              <td className="px-[9px] py-1 text-ui-text-secondary">
                {history?.LastLocation ?? "-"}
              </td>
            </tr>
          ))}
          {events.length === 0 && (
            <tr>
              <td
                colSpan={4}
                className="px-2.5 py-4 text-center font-manrope text-[10.5px] font-medium text-ui-text-muted"
              >
                {t("invoice.noTrackingEventsOnThis")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Panel>
  );
};

export default TrackingPanel;
